import { ReactNode } from "react";

export default function TextNumeric({ children }: { children: ReactNode }) {
  return <div style={{ fontVariantNumeric: "tabular-nums" }}>{children}</div>;
}
